<template lang="pug">
  b-modal#editProvider(
  ref="editProvider"
  :title="$t('ui.combine.edit_provider')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-3
        div.form-control.form-control-sm.disabled {{ getProviderId }}
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          ref="dataEdit_providerName"
          required
          type="text"
          :dirty="$v.dataEdit_providerName.$dirty"
          :error="$v.dataEdit_providerName.$error"
          v-model.trim.lazy="$v.dataEdit_providerName.$model"
          :disabled="loading"
          @focus.native="$event.target.select()"
          :maxLength="$v.dataEdit_providerName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataEdit_providerName" :name="$t('ui.name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    providerId: "",
    providerName: ""
  },
  data() {
    return {
      dataEdit_providerName: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    getProviderId: function() {
      return this.providerId;
    }
  },
  validations: {
    dataEdit_providerName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    }
  },
  watch: {
    providerName: function(newVal) {
      this.dataEdit_providerName = newVal;
    }
  },
  methods: {
    test: function(event) {
      alert("123" + event);
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.editProviderUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.provider,
          target_provider_id: this.providerId,
          new_provider_name: this.dataEdit_providerName
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.providerId, this.dataEdit_providerName);
                  this.$refs.editProvider.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_provider", this.feedback.status);
                  this.$refs.editProvider.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
      this.dataEdit_providerName = this.providerName;
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataEdit_providerName.$el.focus();
    }
  }
};
</script>
